import { Component } from "react";
import { formatUrlSeo } from "../../util/seo-url";
import EllipsisText from 'react-ellipsis-text';
import React = require("react");
import Spinner from '../share/Spinners/Spinners'
import { loadImage } from "../../util/image";
import TinTucService from "../../services/tinTuc";
import { DANH_MUC } from "../../const/danh-muc";
import { TinTuc } from "../../models";
import Link from "next/link";
import * as _ from "lodash";
var Chance = require('chance');
const chance = new Chance();

import Image from "../../components/share/Image";
import { NEWS } from "../../const/seo-url";
import CarouselSlide from "../share/CarouselSlide";
import SpinnersHDVH from "../share/Spinners/SpinnersImageText";

export default class extends Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      tinQuanTam: [],
      loading: false,
      firstDuAn: null,
      slides: []
    }
  }

  static async getInitialProps() {

    return
  }


  componentDidMount() {
    TinTucService.getList(
      DANH_MUC.HOAT_DONG_VUI_HOC,
      1,
      12
    ).then(value => {
      if (value.danhSachTinTuc) {
        if (value.danhSachTinTuc.length > 0) {
          let numberTinTusPerSlide = 3;
          let numberOfSlide = getNumberOfSlide(value.danhSachTinTuc.length);
          let listOfTinTucsPerSlide = _.chunk(value.danhSachTinTuc, numberTinTusPerSlide);
          for (let i = 0; i < numberOfSlide; i++) {
            let guid = chance.guid();
            this.state.slides.push(<Slide key={guid} tinTucs={listOfTinTucsPerSlide[i]} />);
            value.danhSachTinTuc.forEach(element => {
              element['url_seo_du_an'] = formatUrlSeo(element['url'], element['id']);
            });
          }
        }
        this.setState({
          loading: true
        });

      }
    });
  }

  render() {
    return (
      <div className="block-nopadding back-hoatdongvuihoc">
        <div className="container nopadding">
          <div className="row">
            <div className="col text-center block-title">
            NEWS
          </div>
          </div>
          {
            this.state.loading ? (
              <div>
                <CarouselSlide
                  id="hoatdongvuihocCarousel"
                  arrowNextClass="carousel-control-next-event"
                  arrowPrevClass="carousel-control-prev-event"
                >
                  {this.state.slides}
                </CarouselSlide>
                <div className="row col">
                  <div className="col-md-12">
                    <div className="col text-right" style={{ padding: 0 }}>
                      <Link href="/news" legacyBehavior>
                        <a className="more text-orange">
                          <b>See all &gt;&gt; </b>
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ) : <SpinnersHDVH type={'placeholde'} loading={true} />
          }



        </div>
      </div>


    );

  }
}
const Slide = ({ tinTucs }: { tinTucs: TinTuc[] }) => {
  return (
    <div className="row" style={{margin: "0px"}}>
      {tinTucs.map(tinTuc => (
        <div key={tinTuc.id} className="col-md-4">
          <div className="hoatdongvuihoc">
            <a href={`/${NEWS.TIN_TUC}/${tinTuc.url_seo_tin}`} className="case_studies--item case_studies--item-child hotspot-wrapper" >
              <div className="img">
                <Image src={tinTuc.hinhThumbnail} alt="" className="img-responsive" classPlaceHolder="lazy-image-list" />
              </div>
              <div className="desc">
                <div className="text text-orange">
                  <strong>{tinTuc.tieuDe}</strong>
                </div>
                <div className="trimtext"  style={{ lineHeight: 1.6, WebkitLineClamp: 3, display: '-webkit-box', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                  {tinTuc.moTa}
                </div>
                <div className="more text-orange text-right">See more &gt;&gt;</div>
              </div>
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};
function getNumberOfSlide(numberOfTinTuc: number): number {
  if (numberOfTinTuc <= 3) {
    return 1;
  }
  if (numberOfTinTuc <= 9) {
    return 2;
  }
  if (numberOfTinTuc <= 12) {
    return 3;
  }
  return 3;
}
